import axios from "axios";

export default {
    get: (ctrl) => axios.get("/api/app_info/read", ctrl ? { signal: ctrl.signal } : null),
    getCustomIcons: (ctrl) => axios.get("/api/app_info/get_custom_icons", ctrl ? { signal: ctrl.signal } : null),
};
